import { render, staticRenderFns } from "./PositionDepartment.vue?vue&type=template&id=a4d3d6a0&scoped=true"
import script from "./PositionDepartment.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionDepartment.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionDepartment.vue?vue&type=style&index=0&id=a4d3d6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d3d6a0",
  null
  
)

export default component.exports